import { render, staticRenderFns } from "./DpKopf.vue?vue&type=template&id=3bb7e700&scoped=true&"
import script from "./DpKopf.vue?vue&type=script&lang=js&"
export * from "./DpKopf.vue?vue&type=script&lang=js&"
import style0 from "./DpKopf.vue?vue&type=style&index=0&id=3bb7e700&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../home/zarzar/Documents/public-solution/bis-office/web/zeitkontrolle/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb7e700",
  null
  
)

export default component.exports